import { render, staticRenderFns } from "./HeadingPanel.vue?vue&type=template&id=563aa1c2&scoped=true&"
import script from "./HeadingPanel.vue?vue&type=script&lang=js&"
export * from "./HeadingPanel.vue?vue&type=script&lang=js&"
import style0 from "./HeadingPanel.css?vue&type=style&index=0&id=563aa1c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563aa1c2",
  null
  
)

export default component.exports